export const MAX_HOMEWORK_PHOTOS = 5;
export const MAX_HOMEWORK_PHOTO_BYTES = 8 * 1024 * 1024;

export const ALLOWED_HOMEWORK_MIME = new Set([
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
  "image/gif",
  "image/heic",
  "image/heif",
]);

export function mimeFromUpload(type: string, filename: string): string | null {
  const normalized = type.toLowerCase();
  if (ALLOWED_HOMEWORK_MIME.has(normalized)) {
    return normalized === "image/jpg" ? "image/jpeg" : normalized;
  }
  const name = filename.toLowerCase();
  if (name.endsWith(".jpg") || name.endsWith(".jpeg")) return "image/jpeg";
  if (name.endsWith(".png")) return "image/png";
  if (name.endsWith(".webp")) return "image/webp";
  if (name.endsWith(".gif")) return "image/gif";
  if (name.endsWith(".heic")) return "image/heic";
  if (name.endsWith(".heif")) return "image/heif";
  return null;
}

export function extForMime(mime: string): string {
  switch (mime) {
    case "image/png":
      return ".png";
    case "image/webp":
      return ".webp";
    case "image/gif":
      return ".gif";
    case "image/heic":
      return ".heic";
    case "image/heif":
      return ".heif";
    default:
      return ".jpg";
  }
}
